import { httpCreate } from './http';

const http = httpCreate('/srv/fund-detail');

export const fundDetail = {
	// 转入钱包余额
	transfer(data) {
		return http.post('/transfer', data);
	},
	// 钱包账单
	getWalletList(params) {
		return http.get(`/wallet/list`, { params });
	},
	// 收益账单
	getList(params) {
		return http.get(`/list`, { params });
	},
	// 钱包收益类型
	walletTypeList(params) {
		return http.get('/wallet/typeList', { params });
	},
	// 收益类型
	typeList(params) {
		return http.get('/typeList', { params });
	},
	// 互动连麦明细
	rtcInfoList(fundId, params) {
		return http.get(`/rtc/${fundId}/list`, { params });
	},
};
